import type { GearSlot, Rarity, Tier } from '../model/types.ts';

/** Published drop weights. Percents are weight / total, shown in the hero screen. */
export const DROP_TABLES: Record<Tier, { rarity: Rarity; weight: number }[]> = {
  1: [
    { rarity: 'common', weight: 700 },
    { rarity: 'uncommon', weight: 220 },
    { rarity: 'rare', weight: 60 },
    { rarity: 'epic', weight: 18 },
    { rarity: 'legendary', weight: 2 },
  ],
  2: [
    { rarity: 'common', weight: 520 },
    { rarity: 'uncommon', weight: 300 },
    { rarity: 'rare', weight: 120 },
    { rarity: 'epic', weight: 48 },
    { rarity: 'legendary', weight: 12 },
  ],
  3: [
    { rarity: 'common', weight: 400 },
    { rarity: 'uncommon', weight: 300 },
    { rarity: 'rare', weight: 180 },
    { rarity: 'epic', weight: 90 },
    { rarity: 'legendary', weight: 30 },
  ],
};

export const TIER_NAME: Record<Tier, string> = {
  1: 'Threadbare',
  2: 'Bronzed',
  3: 'Riveted',
};

export const SLOT_NOUN: Record<GearSlot, string> = {
  weapon: 'Blade',
  offhand: 'Kite',
  helm: 'Helm',
  chest: 'Coat',
  gloves: 'Grips',
  boots: 'Boots',
};

export const RARITY_LABEL: Record<Rarity, string> = {
  common: 'Common',
  uncommon: 'Uncommon',
  rare: 'Rare',
  epic: 'Epic',
  legendary: 'Legendary',
};

/** Flat stats before tier, rarity, and enhance. */
export const SLOT_BASE_STATS: Record<GearSlot, { hp: number; attack: number; armor: number; armorBreak: number; heal: number }> = {
  weapon: { hp: 0, attack: 12, armor: 0, armorBreak: 0, heal: 0 },
  offhand: { hp: 10, attack: 0, armor: 8, armorBreak: 0, heal: 2 },
  helm: { hp: 8, attack: 0, armor: 10, armorBreak: 0, heal: 0 },
  chest: { hp: 22, attack: 0, armor: 8, armorBreak: 0, heal: 0 },
  gloves: { hp: 0, attack: 7, armor: 3, armorBreak: 4, heal: 0 },
  boots: { hp: 6, attack: 2, armor: 5, armorBreak: 0, heal: 0 },
};

export const TIER_STAT_MULT: Record<Tier, number> = { 1: 1, 2: 1.65, 3: 2.5 };

export const RARITY_STAT_MULT: Record<Rarity, number> = {
  common: 1,
  uncommon: 1.22,
  rare: 1.5,
  epic: 1.85,
  legendary: 2.35,
};
